import { Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";
import { handleDragDropEvent, handlePasteEvent } from "../commands";
export const filestackUploadPluginKey = new PluginKey("filestackUploadPluginKey");
export const filestackUploadPlugin = (filestackService) => {
    return new Plugin({
        key: filestackUploadPluginKey,
        props: {
            decorations: (state) => filestackUploadPluginKey.getState(state),
            handleDOMEvents: {
                drop: (view, event) => {
                    return handleDragDropEvent(event, view, filestackService);
                },
                paste: (view, event) => {
                    return handlePasteEvent(event, view, filestackService);
                },
            },
        },
        // the plugin state manages the upload placeholder as widget decorations
        state: {
            init: () => DecorationSet.empty,
            apply: (tr, set) => {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                const action = tr.getMeta(filestackUploadPluginKey);
                if (action === null || action === void 0 ? void 0 : action.add) {
                    const deco = Decoration.widget(action.add.pos, action.add.widget, {
                        id: action.add.id,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    });
                    return set.add(tr.doc, [deco]);
                }
                else if (action === null || action === void 0 ? void 0 : action.remove) {
                    return set.remove(set.find(null, null, (spec) => spec.id === action.remove.id));
                }
                return set;
            },
        },
    });
};
/**
 * Returns a transaction that creates an upload placeholder for the given file and position.
 */
export function insertUploadPlaceholder(tr, id, pos, file) {
    tr.setMeta(filestackUploadPluginKey, {
        add: { id, pos, widget: createPlaceholderWidget(file) },
    });
    tr.insertText(" "); // insert a space to make cursor jump after the inserted widget decoration
    return tr;
}
/**
 * Removes the upload placeholder widget decoration identified by the given `id`.
 */
export function removeUploadPlaceholder(tr, id) {
    return tr.setMeta(filestackUploadPluginKey, { remove: { id } });
}
/**
 * Returns the position of a upload placeholder widget decoration specified by the given `id`.
 */
export function findPlaceholderPosition(state, id) {
    const decos = filestackUploadPluginKey.getState(state);
    const found = decos.find(null, null, (spec) => spec.id === id);
    return found.length ? found[0].from : null;
}
function createPlaceholderWidget(file) {
    if (file.type.startsWith("image")) {
        return createPlaceholderImage(file);
    }
    const span = document.createElement("span");
    span.classList.add("editor-attachment-placeholder");
    span.textContent = file.name;
    return span;
}
function createPlaceholderImage(file) {
    const wrapper = document.createElement("span");
    wrapper.classList.add("editor-image-placeholder");
    // add this class while FileReader hasn't finished loading the image into memory to show placeholder preview
    // this is necessary for large images, when browser takes a while to show the image preview
    wrapper.classList.add("editor-image-placeholder__reading");
    const img = document.createElement("img");
    const fileReader = new FileReader();
    fileReader.onload = () => {
        img.src = fileReader.result;
        wrapper.classList.remove("editor-image-placeholder__reading");
    };
    fileReader.readAsDataURL(file);
    wrapper.appendChild(img);
    return wrapper;
}
